import { Component, EventEmitter, Input, Output } from '@angular/core';
import { OrderService } from '../order.service';
import { SpinnerService } from '../../shared/spinner/spinner.service';
import { Package } from '../../entity/package';

@Component({
  selector: 'package-selector',
  templateUrl: './package-selector.component.html'
})
export class PackageSelectorComponent {

  @Input() search: string;
  @Input() packages: Package[];
  @Input() showButtons: boolean;
  @Input() selectedPackages: Package[];
  @Output() onPackageSelected = new EventEmitter<Package>();
  @Output() onCancelSelection = new EventEmitter();
  @Output() onFinishSelection = new EventEmitter();


  constructor(private orderService: OrderService, private spinnerService: SpinnerService)
  {
    this.packages = new Array();
    this.selectedPackages = new Array();
  }

  ngDoCheck(): void
  {
    for(let packageIndex = 0; packageIndex < this.selectedPackages.length; packageIndex++){
      let selectedPackage = this.selectedPackages[packageIndex];
      if(!selectedPackage.inArray(this.packages)){
       this.selectPackage(null, selectedPackage);
       selectedPackage.removeFromArray(this.selectedPackages);
       //On décrémente l'index pour ne pas sauter de case
       packageIndex--;
      }
    }
  }

  public selectPackage(event: any, pack: Package): void
  {
    this.onPackageSelected.emit(pack);
  }

  public cancelSampleSelection(): void
  {
    this.onCancelSelection.emit();
  }

  public finishSampleSelection(): void
  {
    this.onFinishSelection.emit();
  }

  public trimSearch(): void
  {
    this.search = this.search.trim();
  }
}



// WEBPACK FOOTER //
// ./src/app/order/package-selector/package-selector.component.ts